var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRuFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_357_2768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 0.91861C15.0603 0.91861 17.8308 2.1592 19.8361 4.16433C21.8413 6.16964 23.0819 8.94014 23.0819 12C23.0819 15.06 21.8413 17.8305 19.836 19.8356C17.8308 21.8409 15.0603 23.0815 12.0004 23.0815C8.94052 23.0815 6.17002 21.8409 4.16471 19.8358C2.15954 17.8305 0.918945 15.06 0.918945 12C0.918945 8.94014 2.15954 6.16964 4.16471 4.16433C6.17002 2.1592 8.94052 0.91861 12.0004 0.91861Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1445 12.0109H1.85659L1.85645 12C1.85645 6.39754 6.39798 1.85596 12.0005 1.85596C17.6029 1.85596 22.1446 6.39754 22.1446 12L22.1445 12.0109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.85645 12.0109H22.1443C22.1385 17.6083 17.5992 22.1441 12.0004 22.1441C6.40145 22.1441 1.86226 17.6083 1.85645 12.0109Z",
    fill: "#D52B1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.43976 8.60391H21.5613C21.9385 9.66572 22.1446 10.8087 22.1446 12.0001C22.1446 13.1994 21.9359 14.3499 21.5537 15.4179H2.44735C2.06513 14.3499 1.85645 13.1994 1.85645 12.0001C1.85645 10.8087 2.06251 9.66572 2.43976 8.60391Z",
    fill: "#0039A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_357_2768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuFlag);
export default __webpack_public_path__ + "static/media/ruFlag.d209da224ee59a91486ba6577175a84a.svg";
export { ForwardRef as ReactComponent };